import React, { useEffect, useState } from 'react'
import { withStyles, createStyles } from '@mui/styles'
import { Dialog, DialogTitle, DialogContent, DialogActions, Link } from '@mui/material'
import { DeleteOutlined } from '@mui/icons-material'
import { Button, ColumnDescriptor, DataTable } from '../common/customComponents'
import { muiOptions, defaultStyles } from '../../infrastructure/materialUiThemeProvider'
import { t } from '../../infrastructure/i18nextHelper'
import { api } from '../../infrastructure/api'
import { UserSettingsContextContainer } from '../../infrastructure/shell/userSettings/userSettingsStore'
import moment from 'moment'

type MktSalesExportFilesDialogProps = {
    open: boolean
    onClose: () => void
    classes?: any
}

type ExportFile = {
    id: string
    demandDate: Date
    fileName: string
    status: string
    elapsedTime: string
    associationKey: string
    downloadUrl: string
}

function _MktSalesExportFilesDialog(props: MktSalesExportFilesDialogProps) {
    let [exportFiles, setExportFiles] = useState<ExportFile[]>([])
    let settings = UserSettingsContextContainer.useContainer()
    let dateFormat = settings.getDateFormat()
    let tBase = 'mktSales.exportFile.'

    let load = async () => {
        let result = await api.get<ExportFile[]>('document/exportFile')
        setExportFiles(result)
    }

    async function deleteDocument(id: string, associationKey: string) {
        await api.del(`document/${associationKey}/${id}`)
        load()
    }

    useEffect(() => {
        if (props.open) {
            load()
        }
    }, [props.open])

    let columns: ColumnDescriptor<ExportFile>[] = [
        {
            name: t(tBase + 'demandDate'),
            value: x => moment(x.demandDate).format(`${dateFormat} h:mm a`),
        },
        {
            name: t(tBase + 'name'),
            value: x => x.fileName,
        },
        {
            name: t(tBase + 'status'),
            value: x => x.status,
        },
        {
            name: t(tBase + 'elapsedTime'),
            value: x => settings.getFormatElapsedTime(x.elapsedTime),
        },
        {
            name: t(tBase + 'link'),
            value: x => (
                <Link onClick={() => window.open(x.downloadUrl, '_blank')}>
                    {t(tBase + 'Download')}
                </Link>
            )
        }
    ]

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>{t('mktSales.table.exportFiles')}</DialogTitle>
            <DialogContent dividers={true} className={props.classes.noPadding + ' ' + props.classes.minSize}>
                <div className={props.classes.container}>
                    <DataTable
                        items={exportFiles}
                        isSelectable={false}
                        idSelector={(x: ExportFile) => x.id}
                        columns={columns}
                        actions={[
                            {
                               name: 'deleteDocument', action: (x: ExportFile) => deleteDocument(x.id, x.associationKey),
                                isBodyAction: true, noMarginOnIcon: true,
                                icon: <DeleteOutlined />
                            }
                        ]} />
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    className={props.classes.closeButton}
                    label={t('shell.userSettings.dialogClose')}
                    onClick={props.onClose}
                    color='primary' />
            </DialogActions>
        </Dialog>
    )
}

let styles = () => createStyles({
    container: {
        ...defaultStyles.flexColumn,
        margin: '1em'
    }
})

export let MktSalesExportFilesDialog = withStyles(styles, muiOptions)(_MktSalesExportFilesDialog)
